import React, { Component } from "react";
import { findIndex } from "lodash";
import DesignTool from "../../designtool";
import {
  RING_SIZE_DEFAULT,
  RING_COLOR_DEFAULT,
  MAX_WIDTH_SP,
  EARRINGS_TYPE_ID
} from "../../const";
import ButtonEdit from "../Button/ButtonEdit";

export default class RingTypeList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleSelect(ring) {
    let items = DesignTool.getItems();
    let {
      handleUpdateState,
      ringIdActive,
      designInfo,
      tmpDesignInfo,
      getWidthBrowser,
      ringTypeList
    } = this.props;

    handleUpdateState("ringIdClick", ring.id);

    if (items.length > 0) {
      //- Ring <=> Earring
      if (ring.id === EARRINGS_TYPE_ID || ringIdActive === EARRINGS_TYPE_ID) {
        handleUpdateState("isShowDialogConfirmTab", true);
        return;
      }

      //- Ring <=> Ring
      if (ring.id !== EARRINGS_TYPE_ID && ringIdActive !== EARRINGS_TYPE_ID) {
        handleUpdateState("isShowDialogConfirmKeepDesign", true);
        return;
      }
    } else {
      handleUpdateState("isShowModalMaterial", true);
      handleUpdateState("idMaterialActive", 1);
      handleUpdateState("ringIdActive", ring.id);

      //- Show tab on SP version
      if (MAX_WIDTH_SP > getWidthBrowser()) {
        handleUpdateState("isShowModalRingList", true);
        handleUpdateState("isShowPopupSp", true);
        handleUpdateState("isShowModalCategoryList", false);
        handleUpdateState("isShowModalFortuneList", false);
        handleUpdateState("isShowModalColorList", false);
      }

      if (ring.id === EARRINGS_TYPE_ID) {
        //- Remove materials tray
        localStorage.setItem("materials", JSON.stringify([]));
        handleUpdateState("isUpdateMaterialsTray", true);
      }

      //- Set default ring select
      let indexItem = findIndex(ringTypeList, item => item.id === ring.id);

      if (indexItem !== -1) {
        let itemRing = ringTypeList[indexItem].rings[0];
        DesignTool.initializeDesignAndDesignInfo(
          ring.id,
          document.getElementById("wrap_draw_tool"),
          {
            size: itemRing.sizes[0].size,
            color: itemRing.colors[0].color_code
          },itemRing,designInfo,tmpDesignInfo
        );
        return;
      }

      //- Update design tool
      DesignTool.initialize(
        ring.id,
        document.getElementById("wrap_draw_tool"),
        {
          size: RING_SIZE_DEFAULT,
          color: RING_COLOR_DEFAULT
        }
      );
    }
  }

  renderCategoryTitle() {
    let { ringIdActive, ringTypeList } = this.props;
    let indexActive = findIndex(ringTypeList, item => item.id === ringIdActive);

    if (indexActive !== -1) {
      return ringTypeList[indexActive].name;
    }

    return "";
  }

  render() {
    let { ringTypeList, ringIdActive } = this.props;

    return (
      <div className="select_title">
        <h3>ベースを選択</h3>
        <div className="dropdown">
          <button
            className="btn btn-secondary dropdown-toggle"
            id="dropdownProduct"
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            {this.renderCategoryTitle()}
          </button>
          <ul className="dropdown-menu" aria-labelledby="dropdownProduct">
            {ringTypeList.map((ring, index) => (
              <li
                key={index}
                onClick={() => this.handleSelect(ring)}
                className={`${
                  ringIdActive === ring.id ? "font-weight-bold" : ""
                }`}
              >
                {ring.name}
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }
}
